import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ShoppingCart, User, Menu, X } from 'lucide-react';
import { useAuth } from '../App';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="bg-white border-b border-border sticky top-0 z-50">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3" data-testid="logo-link">
            <img src="/ambika-logo.jpg" alt="Ambika Fashion" className="h-12 md:h-16 w-auto" />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/products" className="text-foreground hover:text-primary font-medium transition-colors" data-testid="products-nav-link">
              Collections
            </Link>
            <Link to="/book" className="text-foreground hover:text-primary font-medium transition-colors" data-testid="book-appointment-nav-link">
              Book Appointment
            </Link>
            {user && (
              <Link to="/dashboard" className="text-foreground hover:text-primary font-medium transition-colors" data-testid="dashboard-nav-link">
                Dashboard
              </Link>
            )}
          </div>

          {/* Right Side Icons */}
          <div className="flex items-center space-x-6">
            {user ? (
              <>
                <Link to="/cart" className="text-foreground hover:text-primary transition-colors" data-testid="cart-icon-link">
                  <ShoppingCart size={24} />
                </Link>
                <div className="relative group">
                  <button className="text-foreground hover:text-primary transition-colors" data-testid="user-menu-button">
                    <User size={24} />
                  </button>
                  <div className="absolute right-0 mt-2 w-48 bg-white border border-border shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                    <Link to="/dashboard" className="block px-4 py-3 hover:bg-accent transition-colors" data-testid="user-dashboard-link">
                      My Account
                    </Link>
                    <button onClick={handleLogout} className="w-full text-left px-4 py-3 hover:bg-accent transition-colors" data-testid="logout-button">
                      Logout
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <Link to="/auth" data-testid="auth-link">
                <button className="bg-primary text-primary-foreground hover:bg-primary/90 px-6 py-2 font-medium transition-all duration-300">
                  Login
                </button>
              </Link>
            )}
            
            {/* Mobile Menu Button */}
            <button 
              className="md:hidden text-foreground"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              data-testid="mobile-menu-toggle"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-border" data-testid="mobile-menu">
            <Link to="/products" className="block py-3 text-foreground hover:text-primary" onClick={() => setMobileMenuOpen(false)}>
              Collections
            </Link>
            <Link to="/book" className="block py-3 text-foreground hover:text-primary" onClick={() => setMobileMenuOpen(false)}>
              Book Appointment
            </Link>
            {user && (
              <Link to="/dashboard" className="block py-3 text-foreground hover:text-primary" onClick={() => setMobileMenuOpen(false)}>
                Dashboard
              </Link>
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
